import { render } from "./CopyGameView.vue?vue&type=template&id=14cbaa85"
import script from "./CopyGameView.vue?vue&type=script&lang=js"
export * from "./CopyGameView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__